<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.personneMorale.contextes.detail.title') +
            (this.form.libelle ? ' ' + this.form.libelle : '')
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.personneMorale.contextes.detail.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pt-0">
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12" md="2" sm="12">
            <v-text-field
              dense
              filled
              v-model="form.id"
              :label="
                $t('administration.personneMorale.contextes.detail.form.id')
              "
              readonly
            />
          </v-col>
          <v-col cols="12" md="4" sm="12">
            <v-text-field
              dense
              filled
              :rules="[obligatoireRule()]"
              v-model="form.libelle"
              :label="
                $t(
                  'administration.personneMorale.contextes.detail.form.libelle',
                )
              "
            />
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <v-text-field
              dense
              filled
              v-model="form.description"
              :rules="[obligatoireRule()]"
              :label="
                $t(
                  'administration.personneMorale.contextes.detail.form.description',
                )
              "
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              filled
              :label="
                $t(
                  'administration.personneMorale.contextes.detail.form.commentaire',
                )
              "
              v-model="form.commentaire"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-select
              return-object
              dense
              filled
              multiple
              chip
              v-model="form.voit"
              :items="enums.voit"
              prepend-inner-icon="mdi-eye"
              item-text="libelle"
              item-value="id"
              :label="
                $t('administration.personneMorale.contextes.detail.form.voit')
              "
              @change="voitChanged()"
            >
              <template #selection="{item}">
                <v-chip small color="secondary"> {{ item.libelle }}</v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-select
              return-object
              dense
              filled
              multiple
              chip
              v-model="form.visibleDe"
              :items="enums.visibleDe"
              prepend-inner-icon="mdi-lighthouse-on"
              item-text="libelle"
              item-value="id"
              :label="
                $t(
                  'administration.personneMorale.contextes.detail.form.visibleDe',
                )
              "
              @change="visibleDeChanged()"
            >
              <template #selection="{item}">
                <v-chip small color="secondary"> {{ item.libelle }}</v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="!control.modeCreation" text color="error" @click="remove">
        {{ $t('button.delete') }}
      </v-btn>
      <v-btn text @click="quit">
        {{ $t('button.cancel') }}
      </v-btn>
      <v-btn text color="primary" @click="save">
        {{ $t('button.save') }}
      </v-btn>

      <v-dialog v-model="control.confirmQuit" persistent max-width="50%">
        <v-card>
          <v-card-title class="accent white--text">
            <v-icon color="white">mdi-alert</v-icon> Édition en cours
          </v-card-title>
          <v-card-text class="body-1">
            <p class="pt-4">
              Vous allez quitter la page actuelle et perdre toutes les
              modifications non sauvegardées.
            </p>
            <p>
              Êtes-vous sûr de vouloir continuer ?
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="control.onConfirmQuit">
              {{ $t('button.yes') }}
            </v-btn>
            <v-btn text @click="abortQuit()">
              {{ $t('button.no') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="control.confirmRemove" persistent max-width="50%">
        <v-card>
          <v-card-title class="accent white--text">
            <v-icon color="white">mdi-alert</v-icon> Suppression de contexte
          </v-card-title>
          <v-card-text class="body-1">
            <p class="pt-4">
              Vous vous apprêtez à supprimer ce contexte.
            </p>
            <p>
              Êtes-vous sûr de vouloir continuer ?
            </p>
            <p>
              Note : la suppression ne fonctionnera que si aucune personne
              morale n'est dans ce contexte.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="doRemove()">
              {{ $t('button.yes') }}
            </v-btn>
            <v-btn text @click="abortRemove()">
              {{ $t('button.no') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="control.confirmError" persistent max-width="50%">
        <v-card>
          <v-card-title class="error white--text">
            <v-icon color="white">mdi-alert</v-icon
            >{{ this.control.error.title }}
          </v-card-title>
          <v-card-text class="body-1">
            <p class="pt-4">
              {{ this.control.error.message }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="confirmError()">
              {{ $t('button.ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import ValidationRules from '@/plugins/mixins/ValidationRules';
import toasted from '@/utils/toasted';
import _ from 'lodash';

export default {
  mixins: [ValidationRules],
  props: {
    /** Titre de la page */
    title: {
      type: String,
      default: null,
    },
    /** Les infos pour le retour vers le menu paramétrage */
    returnRoute: {},
    id: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      // Les enums
      enums: {
        voit: [],
        visibleDe: [],
      },

      // Le formulaire
      form: {
        id: null,
        libelle: '',
        description: '',
        commentaire: '',

        // Collections de contextes
        voit: [],
        visibleDe: [],
      },

      // Pour éviter de quitter intempestivement
      control: {
        modeCreation: false,
        initial: null,
        confirmQuit: false,
        onConfirmQuit: null,
        confirmRemove: false,
        confirmError: false,
        error: {
          title: '',
          message: '',
        },
      },
    };
  },
  created() {
    this.initEnums();
  },
  mounted() {
    this.load();
  },
  watch: {
    $route() {
      this.load();
    },
    'form.libelle'(val) {
      // En création on ajoute une ligne aux v-select des contextes, pour que le contexte puisse se voir lui-même
      if (this.control.modeCreation) {
        if (val && val.length > 0) {
          this.enums.voit[0].libelle = val;
          this.enums.visibleDe[0].libelle = val;
        } else {
          this.enums.voit[0].libelle = this.$t(
            'administration.personneMorale.contextes.detail.form.ceContexte',
          );
          this.enums.visibleDe[0].libelle = this.$t(
            'administration.personneMorale.contextes.detail.form.ceContexte',
          );
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    // Pour eéviter de quiter intempestivement
    if (!_.isEqual(this.form, this.control.initial)) {
      this.control.confirmQuit = true;
      this.control.onConfirmQuit = next;
    } else {
      next();
    }
  },
  methods: {
    load() {
      var id = null;
      if (this.$route && this.$route.params && this.$route.params.id) {
        id = this.$route.params.id;
      }
      this.control.modeCreation = !id;
      if (!this.control.modeCreation) {
        this.loadEntity(id);
      } else {
        this.loadNew();
      }
    },
    // Init en cas de modification
    loadEntity(id) {
      this.$api('administration/contextes/contexte/' + id)
        .get()
        .then(response => {
          this.initForm(response.body);
        });
    },
    // Init en cas de création
    loadNew() {
      this.initForm({});
    },
    initForm(loaded) {
      this.form.id = loaded.id || null;
      this.form.libelle = loaded.libelle || '';
      this.form.description = loaded.description || '';
      this.form.commentaire = loaded.commentaire || '';
      // Collections
      this.form.voit = loaded.voit || [];
      this.form.visibleDe = loaded.visibleDe || [];

      this.control.initial = JSON.parse(JSON.stringify(this.form));
    },

    // Chargement des listes d'enums depuis le Back
    initEnums() {
      this.$api('administration/contextes/contexte-enum')
        .get()
        .then(response => {
          const body = response.body;
          const enums = this.enums;
          enums.voit = body.contextes;
          enums.visibleDe = body.contextes;
          if (this.modeCreation) {
            // En création onn ajoute une ligne aux v-select des contextes, pour que le contexte puisse se voir lui-même
            enums.voit.unshift({
              id: null,
              libelle: this.$t(
                'administration.personneMorale.contextes.detail.form.ceContexte',
              ),
            });
            enums.visibleDe.unshift({
              id: null,
              libelle: this.$t(
                'administration.personneMorale.contextes.detail.form.ceContexte',
              ),
            });
          }
        });
    },

    // Lorsque l'utilisateur modifie la collection voit, on modifie la collection visibleDe
    voitChanged() {
      var ceContexte = {
        id: this.form.id,
        libelle: this.form.libelle,
      };

      var ceContexteVoitIndex = this.form.voit.findIndex(
        c => c.id == this.form.id,
      );
      if (ceContexteVoitIndex >= 0) {
        this.collectionAdd(this.form.visibleDe, ceContexte);
      } else {
        this.collectionRemove(this.form.visibleDe, ceContexte);
      }
    },
    // Lorsque l'utilisateur modifie la collection visibleDe, on modifie la collection voit
    visibleDeChanged() {
      var ceContexte = {
        id: this.form.id,
        libelle: this.form.libelle,
      };

      var ceContexteVisibleDeIndex = this.form.visibleDe.findIndex(
        c => c.id == this.form.id,
      );
      if (ceContexteVisibleDeIndex >= 0) {
        this.collectionAdd(this.form.voit, ceContexte);
      } else {
        this.collectionRemove(this.form.voit, ceContexte);
      }
    },
    // Ajoute item à la colletcion s'il n'y est pas déjà
    collectionAdd(collection, item) {
      var index = collection.findIndex(c => c.id == item.id);
      if (index < 0) {
        collection.push(item);
      }
    },
    // Supprime item de la collection, s'il y est
    collectionRemove(collection, item) {
      var index = collection.findIndex(c => c.id == item.id);
      if (index >= 0) {
        collection.splice(index, 1);
      }
    },

    getForms() {
      //access aux formulaire à créer
      return [this.$refs.form];
    },

    // Save
    save() {
      this.doSave();
    },
    doSave() {
      const ok = this.getForms()
        .map(f => f.validate())
        .every(v => !!v);
      if (ok) {
        if (this.form.id) {
          this.doUpdate();
        } else {
          this.doCreate();
        }
      }
    },
    doUpdate() {
      this.$api('administration/contextes/contexte/' + this.form.id)
        .post(this.form)
        .then(
          response => {
            this.initForm(response.body);
            toasted.info('form.saved');
            this.doQuit();
          },
          () => {
            toasted.error('form.error');
          },
        );
    },
    doCreate() {
      this.$api('administration/contextes/contexte')
        .put(this.form)
        .then(
          response => {
            this.initForm(response.body);
            toasted.info('form.saved');
            this.doQuit();
          },
          () => {
            toasted.error('form.error');
          },
        );
    },

    // Delete
    remove() {
      this.control.confirmRemove = true;
    },
    abortRemove() {
      this.control.confirmRemove = false;
    },
    doRemove() {
      this.$api('administration/contextes/contexte/' + this.form.id)
        .delete()
        .then(() => {
          toasted.info('form.deleted');
          this.control.confirmRemove = false;
          this.doQuit();
        })
        .catch(errors => {
          this.control.confirmRemove = false;
          this.control.error.title = this.$t(
            'administration.personneMorale.contextes.detail.results.delete.error',
          );
          var code =
            'administration.personneMorale.contextes.detail.results.delete.errors.referenced';
          var nb = 0;
          if (
            Array.isArray(errors.globalErrors) &&
            errors.globalErrors.length > 0
          ) {
            var globalError = errors.globalErrors[0];
            if (
              Array.isArray(globalError.codes) &&
              globalError.codes.length > 0
            ) {
              nb = globalError.arguments[0];
            }
            if (
              Array.isArray(globalError.arguments) &&
              globalError.arguments.length > 0
            ) {
              nb = globalError.arguments[0];
            }
          }
          this.control.error.message = this.$tc(code, nb);
          this.control.confirmError = true;
        });
    },
    confirmError() {
      this.control.confirmError = false;
    },

    // Cancel
    quit() {
      if (!_.isEqual(this.form, this.control.initial)) {
        this.control.confirmQuit = true;
        this.control.onConfirmQuit = this.doQuit;
      } else {
        this.doQuit();
      }
    },
    abortQuit() {
      this.control.confirmQuit = false;
    },

    // Quit
    doQuit() {
      this.$router.replace(this.returnRoute);
    },
  },
};
</script>
